import { useTranslation } from 'next-i18next';

import { Page, Section } from '@larvitu/shared/mui/ui-components';

import { FAQS, ServiceHero, SubServiceComponent } from '../../components';
import { ContactUs } from '../../components/contact';
import { getLayout } from '../../lib/getLayout';
import { getServerTranslations } from '../../lib/i18n/getServerTranslations';

import type { AppPage } from '../../@types/page';
import type { GetStaticProps, InferGetStaticPropsType } from 'next';

// actual generalpage
const GeneralService: AppPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = () => {
  const { t } = useTranslation( ['service', 'common', 'faq', 'contact'] );

  return (
    <Page title="General">
      <ServiceHero />
      <SubServiceComponent
        services={t( 'serviceItems', {
          ns: 'service',
          returnObjects: true,
          defaultValue: '',
        } )}
        query="general"
        contactButton={t( 'to-the-contact-form', { ns: 'common' } )}
        subHeader={t( 'subHeader', { ns: 'service' } )}
        readMore={t( 'read-more', { ns: 'common' } )}
      />

      <Section id="contactUs">
        <ContactUs
          header={t( 'arrival', { ns: 'contact' } )}
          openingHours={t( 'opening-hours', {
            ns: 'contact',
            returnObjects: true,
          } )}
          address={t( 'address', { ns: 'contact', returnObjects: true } )}
          content={t( 'content', { ns: 'contact', returnObjects: true } )}
        />

        <FAQS
          items={t( 'items', {
            ns: 'faq',
            returnObjects: true,
          } )}
        />
      </Section>
    </Page>
  );
};

GeneralService.getLayout = getLayout;

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => ({
  props: {
    ...(await getServerTranslations( locale, [
      'service',
      'common',
      'faq',
      'contact',
    ] )),
  },
});

export default GeneralService;
